export default __webpack_public_path__ + "img/fieqNnMW.422df1ce.svg";